import { CloseButtonProps, toast, ToastOptions, ToastPosition } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactElement, ReactNode } from "react";
import { ToastIcon } from "react-toastify/dist/types";

export enum ToastTypes {
  success = "success",
  warning = "warning",
  error = "error",
  promise = "promise",
  info = "info"
}
export interface ToastProps {
  message: string;
  type: ToastTypes;
  icon?: ToastIcon;
  position?: ToastPosition;
  autoClose?: number | false;
  closeButton?: boolean | ((props: CloseButtonProps) => ReactNode) | ReactElement<CloseButtonProps>;
  closeOnClick?: boolean;
  onClick?: () => void;
}

const IyilestirToaster = (props: ToastProps) => {
  const options: ToastOptions = {
    closeOnClick: props.closeOnClick ? props.closeOnClick : true,
    autoClose: props.autoClose === false ? false : typeof props.autoClose === "number" ? props.autoClose : 3000,
    pauseOnHover: true,
    position: props.position ? props.position : "top-center",
    closeButton: props.closeButton ? props.closeButton : false,
    onClick: props.onClick,
    hideProgressBar: true
  };
  switch (props.type) {
    case ToastTypes.success:
      toast.success(props.message, options);
      break;
    case ToastTypes.warning:
      toast.warning(props.message, options);
      break;
    case ToastTypes.error:
      toast.error(props.message, options);
      break;
    case ToastTypes.info:
      toast.info(props.message, options);
      break;

    default:
      break;
  }
};

export default IyilestirToaster;
